<div>
  <input
    type="checkbox"
    [(ngModel)]="params.data.isSelected"
    (click)="onCheckBoxClick()"
    [hidden]="params.data.error">
</div>
